<template>
  <div class="admin">
    <div class="admin-area">
      <div class="admin-triggers">
        <router-link tag="div" class="admin-trigger" active-class="admin-trigger_active" to="/admin/users">Users</router-link>
        <router-link tag="div" class="admin-trigger" active-class="admin-trigger_active" to="/admin/apps">Apps</router-link>
        <router-link tag="div" class="admin-trigger" active-class="admin-trigger_active" to="/admin/app-groups">App Groups</router-link>
        <router-link tag="div" class="admin-trigger" active-class="admin-trigger_active" to="/admin/roles">Roles</router-link>
        <router-link tag="div" class="admin-trigger" active-class="admin-trigger_active" to="/admin/organizations">Organizations</router-link>
        <router-link tag="div" class="admin-trigger" active-class="admin-trigger_active" to="/admin/organizations-assignments">Organization Assignments</router-link>
        <router-link tag="div" class="admin-trigger" active-class="admin-trigger_active" to="/admin/team-assignments">Team Assignments</router-link>
        <router-link tag="div" class="admin-trigger" active-class="admin-trigger_active" to="/admin/teams">Teams</router-link>
        <router-link tag="div" class="admin-trigger" active-class="admin-trigger_active" to="/admin/auth-configs">Authorization Configurations</router-link>

      </div>
      <div class="admin-tabs">
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Admin',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
tbody.md-table-body {
  height: calc(100vh - 270px) !important;
  overflow: auto;
}

.admin-tab .md-table-card .md-table-pagination {
  justify-content: center;
}
thead {
  display: table-header-group !important;
}
tbody tr {
  display: table-row !important;
}
tbody {
  display:  table-row-group !important;
}
.md-table .md-table-cell:last-child .md-table-cell-container {
  padding-left: 24px;
}
.md-table {
  height: calc(100vh - 230px) !important;
}
</style>

<style scoped>
  .admin-triggers {
    width: 100%;
    overflow: auto;
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #ccc;
    height: 40px;
  }
  .admin-triggers::-webkit-scrollbar {
    height: 4px;
  }

.admin-trigger {
  font-size: 13px;
  line-height: 11px;
  font-family: Roboto condensed,sans-serif !important;
  padding: 10px 20px;
  border-bottom: 2px solid transparent;
  user-select: none;
  cursor: pointer;
  transition: all .2s;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: #999;
}

.admin-trigger_active {
  border-bottom: 2px solid #e3217c;
  color: #000;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Admin.vue?f32a63ee